import Paper from '../../../../shared/assets/paper.png';
import Clock from '../../../../shared/assets/clock.png';
import People from '../../../../shared/assets/people.png';
import Lock from '../../../../shared/assets/lock.png';
import Bag from '../../../../shared/assets/bag.png';

export const SERVICE_FEATURES_DATA = [
  {
    title: 'professionalità',
    subTitle: 'professionalità2',
    icon: Paper,
  },
  {
    title: 'call_center',
    subTitle: 'call_center2',
    icon: Clock,
  },
  {
    title: 'dialogo',
    subTitle: 'dialogo2',
    icon: People,
  },
  {
    title: 'costi',
    subTitle: 'costi2',
    icon: Lock,
  },
  {
    title: 'assistenza_personalizzata',
    subTitle: 'assistenza_personalizzata2',
    icon: Bag,
  },
];
